export const getItemWithSuffix = (array: string[], match: string) =>
  array.find(item => match.toLowerCase().endsWith(item.toLowerCase()));



// WEBPACK FOOTER //
// ./src/shared/helpers/getItemWithSuffix.ts